/**
 * @generated SignedSource<<9d531484725b28da0dda6ac5fc5d39d3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type CmsHomepageBannerFormatEnumType = "BURN_IN" | "CAPTION" | "%future added value";
export type HeroBannerSettingsImageWidth = "full" | "half" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type HpSharedSharedHeroBanner_topItem$data = {
  readonly cmsId: number | null;
  readonly cta: string | null;
  readonly format: CmsHomepageBannerFormatEnumType | null;
  readonly heroBannerSettings: {
    readonly backgroundColor: string | null;
    readonly bannerImageWidth: HeroBannerSettingsImageWidth | null;
    readonly contentPosition: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"HpSharedHeroBannerText_heroBannerSettings">;
  } | null;
  readonly imageHeight?: string | null;
  readonly imageUrl?: string | null;
  readonly imageWidth?: string | null;
  readonly isFullBleedImage: boolean | null;
  readonly linkData: {
    readonly path: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"HpSharedHeroBannerText_linkData">;
  };
  readonly mobileImageHeight?: string | null;
  readonly mobileImageUrl?: string | null;
  readonly mobileImageWidth?: string | null;
  readonly " $fragmentType": "HpSharedSharedHeroBanner_topItem";
};
export type HpSharedSharedHeroBanner_topItem$key = {
  readonly " $data"?: HpSharedSharedHeroBanner_topItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedSharedHeroBanner_topItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isMobile"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedSharedHeroBanner_topItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cmsId",
      "storageKey": null
    },
    {
      "condition": "isMobile",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageHeight",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageWidth",
          "storageKey": null
        }
      ]
    },
    {
      "condition": "isMobile",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "mobileImageHeight",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "mobileImageWidth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "mobileImageUrl",
          "storageKey": null
        }
      ]
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LinkData",
      "kind": "LinkedField",
      "name": "linkData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "path",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HpSharedHeroBannerText_linkData"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "HeroBannerSettingsType",
      "kind": "LinkedField",
      "name": "heroBannerSettings",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HpSharedHeroBannerText_heroBannerSettings"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "contentPosition",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "backgroundColor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bannerImageWidth",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cta",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isFullBleedImage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "format",
      "storageKey": null
    }
  ],
  "type": "TopHeroBannerItem",
  "abstractKey": null
};

(node as any).hash = "cf4dced2e9ac1c9cae2b4cf2168e002e";

export default node;
